export function lazyLoadComponent(componentName) {
    return () => import(`@/layouts/${componentName}/${componentName}.vue`);
}
